// LandHo! brand icon — "Tierra a la vista".
// Círculo blanco = horizonte del vigía. Triángulo = tierra asomando.
// Punto arriba a la derecha = el sol/pin/marca. Verde #12855A = paleta LandHo!.
// Se usa en Login y Sidebar. Para tamaños < 20px usar favicon simplificado.
export function BrandIcon({ size = 40, className = "", ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="LandHo"
      className={className}
      {...rest}
    >
      <rect width="64" height="64" rx="15" fill="#12855A" />
      <circle cx="32" cy="33" r="19" fill="none" stroke="#FFFFFF" strokeWidth="2.5" />
      <line x1="14.5" y1="38" x2="49.5" y2="38" stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round" />
      <path d="M20 38 L32 20 L44 38 Z" fill="#FFFFFF" />
      <circle cx="42" cy="24" r="3.2" fill="#FFFFFF" />
    </svg>
  );
}

export default BrandIcon;
